import { ManageBranchesClientService } from "../../../../services/manage/manage-branches.service";
import { BranchModel } from "../../../../models/manage/branches.models";
import { NotificationType, NotificationClientService } from "../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { UnitOfWorkObserver } from "../../../../utilities/unit-of-work-observer";
import { BindingEngine } from "aurelia-binding";
import { autoinject } from "aurelia-framework";

@autoinject
export class ManageBranch {

    private _branchInEditUow: UnitOfWorkObserver
    private _cancelEditing: () => void;
    private _refresh: () => void;
    private _parentBranchId: number;

    public branchInEdit: BranchModel;
    public title: string = "";

    constructor(private manageBranchesService: ManageBranchesClientService,
        private notificationClientService: NotificationClientService,
        private branchClientService: ManageBranchesClientService,
        private i18N: I18N,
        private engine: BindingEngine) { }

    private getEmptyBranch(): BranchModel {
        return {
            isActive: false,
            branchId: 0,
            code: null,
            parentId: null,
            managerId: null,
            branchRegionId: null,
            name: "",
            image: "",
            permissions: [],
            departments: [],
            users: [],
            isDefault: null
        }
    }

    areThereUnsavedChanges() {
        const changes = this._branchInEditUow.getChanges();
        if (!this._branchInEditUow.hasChanges() || (this._branchInEditUow.hasChanges && Object.keys(changes).length == 1 && changes['identifier'])) {
            return false;
        }
        else {
            return true;
        }
    }

    cancel() {
        this._cancelEditing();
    }

    save() {
        return new Promise<void>((resolve, reject) => {
            if (!this.areThereUnsavedChanges()) {
                this.notificationClientService.show(this.i18N.tr('no-changes-performed-text'), this.i18N.tr('there-were-no-changes-to-save-text'), NotificationType.Info, 5000);
                resolve();
                return;
            }

            if (!this.branchInEdit.name) {
                this._branchInEditUow.addChange(x => x.name, "Default Branch", 0);
            }

            if (this.branchInEdit.branchId == 0) {
                this._branchInEditUow.addChange(x => x.parentId, this._parentBranchId, 0);
            }

            this.manageBranchesService.save({
                changes: this._branchInEditUow.getChanges(),
                id: this.branchInEdit.branchId
            }).then(() => {
                this.notificationClientService.show(this.i18N.tr('successfully-saved-text'), this.i18N.tr('branch-has-been-successfully-saved-text'), NotificationType.Success); resolve();
                this._refresh();
            }).catch(() => {
                this.notificationClientService.show(this.i18N.tr('error-text') + "!", this.i18N.tr('branch-cannot-be-saved-text'), NotificationType.Error);
                reject();
            });
        });
    }

    activate(model: any) {
        this._cancelEditing = model.cancelEditing;
        this._refresh = model.refresh;
        this._parentBranchId = model.parentBranchId;
        this.title = model.title;
        const initializeUow = () => {
            if (this._branchInEditUow) {
                this._branchInEditUow.dispose();
            }
            this._branchInEditUow = UnitOfWorkObserver.getTrackingInstance(this.engine, this.branchInEdit);
        };

        if (model.branchId == 0) {
            this.branchInEdit = this.getEmptyBranch();
            initializeUow();
        }
        else {
            this.branchClientService.getBranch({ branchId: model.branchId })
                .then(x => {
                    if (x.isSuccess) {
                        this.branchInEdit = x.branch
                        initializeUow();
                    }
                    else {
                        this.notificationClientService.show(this.i18N.tr('branch-not-found-text'), "", NotificationType.Error);
                    }
                })
                .catch(() => {
                    this.notificationClientService.show(this.i18N.tr('error-text'), "", NotificationType.Error);
                });
        }
    }
}
